<template>
  <div
    class="MapPanel"
    id="MapPanel"
    style="width: 100%;height: 100px;"
  />
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet/dist/leaflet";

export default {
  name: "mapDrawer",
  props: {
    id: {
      required: true,
      type: String,
    },
  },
  components: {},
  computed: {
    authKey: () => process.env.VUE_APP_LEAFLET_API_KEY,
  },
  data() {
    return {
      agMapLoaded: false,
      agMap: null,
    };
  },
  methods: {
    checkIfAgMapLoaded() {
      this.agMapLoaded = !!window.AfriGIS;
      if (this.agMapLoaded) {
        return;
      }
      setTimeout(() => {
        this.checkIfAgMapLoaded();
      }, 500);
    },
    initMap() {
      document.getElementById("MapPanel").style.height = window.innerHeight+"px";
      // eslint-disable-next-line
      this.agMap = AfriGIS.map("MapPanel", {
        // replace zoom level with your default
        zoom: 4,
        // replace center coord with your default
        center: L.latLng(-25, 28),
        zoomControl: true,
        mapType: "Vector",
        authkey: this.authKey,
      });
      this.setMapDefaults();
      this.loadLayer(this.id);
    },
    loadLayer(id) {
      const url = `${process.env.VUE_APP_ROOT_API}/api/mapservers/${id}`;
      
      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(data => {
          const mp = {
            "type": "Feature",
            "geometry": {
              "type": "MultiPolygon",
              "coordinates": data.body.features[0].geometry.coordinates
            },
            "properties": {
              "name": "MultiPolygon",
              "style": {
                  color: "#F78322",
                  opacity: 1,
                  weight: 3,
                  fillColor: "#F78322",
                  fillOpacity: 0.2
              }
            }
          };
          const layer = new L.GeoJSON(mp, {
            style: function(feature) {
                return feature.properties.style
            }
          }).addTo(this.agMap);
          this.agMap.fitBounds(layer.getBounds());
        });
    },
    setMapDefaults() {
      this.agMap.defaults = {
        icon: new L.Icon({
          iconUrl: "red_dot.png",
          iconSize: [16, 16],
          iconAnchor: [8, 8],
          shadowUrl: "dot_shadow.png",
          shadowSize: [16, 16],
          shadowAnchor: [8, 8]
        }),
        editable: true,
        color: "#F78322",
        weight: 3,
        opacity: 1.0,
        fillColor: "#F78322",
        fillOpacity: 0.2
      };
    },
  },
  mounted() {
    this.checkIfAgMapLoaded();
  },
  watch: {
    agMapLoaded(newV) {
      if (!newV) {
        return;
      }
      this.initMap();
    },
  },
};
</script>

<style>
.fullsize {
  width: 100%;
  height: 100%;
}
</style>
